// src/App.js
import React from 'react';
import SahayaaApp from './components/SahayaaApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <SahayaaApp />
    </div>
  );
}

export default App;